<template>
  <v-card class="merits mt-3 elevation-4">
    <v-toolbar card class="transparent">
      <v-toolbar-title class="title">
        Merits
      </v-toolbar-title>
      <v-spacer />
      <can I="edit" a="Profile">
        <v-tooltip left>
          <v-dialog slot="activator" v-model="creating" max-width="600">
            <v-btn small fab slot="activator" color="secondary">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
            <v-card dark>
              <v-card-title class="title">Add a merit</v-card-title>
              <v-card-text>
                <v-form v-model="valid">
                  <v-text-field
                    label="Title"
                    v-model="achievement.title"
                    required :rules="rules.title"
                    :counter="128"
                  />
                  <v-textarea
                    label="Description"
                    v-model="achievement.description"
                    :rules="rules.description"
                    :counter="512"
                    auto-grow
                  />
                  <date-picker
                    v-model="achievement.achievedAt"
                    label="Achieved"
                    append-icon="mdi-calendar"
                    clearable
                    :rules="rules.achievedAt"
                  />
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-btn flat block color="grey" @click="creating = false">Cancel</v-btn>
                <v-btn block color="primary" :disabled="!valid" @click="add">Add</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <span>Add a merit</span>
        </v-tooltip>
      </can>
    </v-toolbar>

    <can I="read" a="Profile">
      <template v-for="achievement in profile.achievements">
        <v-divider />
        <v-card-text class="py-0">
          <Achievement :achievement="achievement" :key="`achievement-${achievement.id}`" />
        </v-card-text>
      </template>
    </can>
  </v-card>
</template>

<script>
// Components
import Achievement from '@/components/profiles/Achievement'

// Helpers
import { mapGetters } from 'vuex'

// Vue Components
export default {
  components: { Achievement },
  data() {
    return {
      creating: false,
      achievement: {
        profile: { id: this.$route.params.id },
        title: '',
        description: '',
        achievedAt: null
      },
      // Validation
      valid: false,
      rules: {
        title: [
          v => !!v || 'You must specify a title',
          v => {
            return !v || (v && v.length < 128) || 'This must be less than 128 characters'
          }
        ],
        description: [
          v => {
            return !v || (v && v.length < 512) || 'This must be less than 512 characters'
          }
        ],
        achievedAt: []
      }
    }
  },
  computed: mapGetters({ profile: 'admin/profiles/find' }),
  methods: {
    add() {
      this.$store.dispatch('admin/achievements/create', this.achievement).then(
        // Success
        reponse => {
          this.$store.commit('snackbar', {
            text: 'Merit was added successfully',
            type: 'success'
          })
          this.$store.dispatch('admin/profiles/fetch', this.profile.id)
          this.creating = false
          this.achievement.title = ''
          this.achievement.description = ''
        },
        // Failure
        errors => {
          this.$store.commit('snackbar', {
            text: 'Merit could not be added',
            type: 'error'
          })
        }
      )
    }
  }
}
</script>

<style>
th.desc,
td.desc {
  width: 40%;
}
</style>
